import App from "@/components/app";
import { globals } from "@/globals";
import "@/globals.css";
import { initI18n } from "@/i18n";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
	faDisplay,
	faGlobe,
	faMobileScreenButton,
	faTabletScreenButton,
} from "@fortawesome/free-solid-svg-icons";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import i18next, { t } from "i18next";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

const queryClient = new QueryClient();

function readSystemTheme(): boolean {
	const themeMatch = matchMedia("(prefers-color-scheme: dark)");
	themeMatch.onchange = (event): void => {
		if (event.matches) {
			document.documentElement.classList.add("dark");
		} else {
			document.documentElement.classList.remove("dark");
		}
	};
	return themeMatch.matches;
}

const themeParam = globals.params.theme;
if (
	themeParam === "dark" ||
	(((!themeParam && window.self === window.top) || themeParam === "system") &&
		readSystemTheme())
) {
	document.documentElement.classList.add("dark");
}

initI18n()
	.then(() => {
		document.documentElement.lang = i18next.language;
		document.title = t("retinboxAccount");
		if (!i18next.language.startsWith("zh")) {
			globals.home = "https://www.retinbox.com/";
		}
	})
	.catch(console.error);

library.add(faDisplay, faGlobe, faMobileScreenButton, faTabletScreenButton);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
	<QueryClientProvider client={queryClient}>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</QueryClientProvider>,
);
